// extracted by mini-css-extract-plugin
module.exports = {"select":"EditableDataTypeFormatter_select__iO1lg"};